// btw-front/src/components/admin/dashboard/NoticesTab.jsx
// [공지사항 관리] 탭 — 공지 목록·등록/수정 이동
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Badge } from "../../ui/Badge";
import { Input } from "../../ui/Input";
import { EmptyState } from "../../ui/EmptyState";
import * as notices from "../../../api/notices";

export default function NoticesTab() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [q, setQ] = useState("");

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    notices
      .list({ q: q || undefined })
      .then((rows) => {
        if (!cancelled) setItems(rows || []);
      })
      .catch(() => {
        if (!cancelled) setItems([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [q]);

  return (
    <div>
      <section className="rounded-2xl border border-slate-200 bg-white p-3">
        <div className="flex flex-wrap items-center gap-3">
          <Input
            name="noticeSearch"
            placeholder={t("admin.filters.searchPlaceholder")}
            value={q}
            onChange={(e) => setQ(e.target.value)}
            className="w-60"
          />
          <button
            type="button"
            onClick={() => navigate("/admin/notices/new")}
            className="btw-btn-accent ml-auto"
          >
            {t("admin.notices.addNotice")}
          </button>
        </div>
      </section>

      <section className="mt-4 overflow-hidden rounded-2xl border border-slate-200 bg-white">
        {loading ? (
          <p className="py-10 text-center text-sm text-slate-400">{t("common.loading")}</p>
        ) : items.length === 0 ? (
          <EmptyState title={t("admin.empty")} />
        ) : (
          <table className="w-full text-sm">
            <thead className="bg-slate-50 text-xs uppercase tracking-wider text-slate-500">
              <tr>
                <th className="px-4 py-2.5 text-left font-medium">
                  {t("admin.notices.table.title")}
                </th>
                <th className="px-4 py-2.5 text-left font-medium">
                  {t("admin.notices.table.status")}
                </th>
                <th className="px-4 py-2.5 text-left font-medium">
                  {t("admin.notices.table.author")}
                </th>
                <th className="px-4 py-2.5 text-left font-medium">
                  {t("admin.notices.table.createdAt")}
                </th>
                <th className="px-4 py-2.5 text-right font-medium">
                  {t("admin.notices.table.attachments")}
                </th>
                <th className="px-4 py-2.5 text-right font-medium">
                  {t("admin.notices.table.views")}
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {items.map((n) => (
                <tr
                  key={n.id}
                  onClick={() => navigate(`/admin/notices/${n.id}/edit`)}
                  className="cursor-pointer transition hover:bg-slate-50"
                >
                  <td className="px-4 py-2.5">
                    <div className="flex items-center gap-2">
                      {n.isPinned && (
                        <span className="rounded bg-slate-100 px-1.5 py-0.5 text-[10px] font-medium text-slate-600">
                          {t("admin.notices.pinnedTag")}
                        </span>
                      )}
                      <span className="font-medium text-slate-900">{n.title}</span>
                    </div>
                  </td>
                  <td className="px-4 py-2.5">
                    <Badge tone={n.status === "published" ? "published" : "draft"}>
                      {n.status === "published"
                        ? t("admin.notices.statusPublished")
                        : t("admin.notices.statusDraft")}
                    </Badge>
                  </td>
                  <td className="px-4 py-2.5 text-slate-700">{n.authorName || "-"}</td>
                  <td className="px-4 py-2.5 text-slate-500">
                    {n.createdAt && String(n.createdAt).slice(0, 10)}
                  </td>
                  <td className="px-4 py-2.5 text-right tabular-nums text-slate-600">
                    {n.attachmentCount || 0}
                  </td>
                  <td className="px-4 py-2.5 text-right tabular-nums text-slate-500">
                    {n.viewCount || 0}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </section>
    </div>
  );
}
